export const INVESTMENT_OBJECTIVE_OPTIONS = [
    {value: "LONG_TERM", name: "Long–term buy & hold investing"},
    {value: "INFREQUENT", name: "Trading infrequently when I see an opportunity"},
    {value: "FREQUENT", name: "Frequent trader, depending on the market"},
    {value: "ACTIVE_DAILY", name: "Active trader, daily trader"},
    {value: "NEW", name: "New to investing"},
]